<template>
  <div>
    <b-modal :active.sync="show" has-modal-card>
      <form action="">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head is-bg-primary">
            <p class="modal-card-title has-text-white">Nilai <span v-if="!isEmpty(account)"> - {{ account.name }}</span></p>
          </header>
          <section class="modal-card-body">
            <b-field label="Periode">
              <b-select placeholder="Pilih periode" v-model="periode_grade">
                <option
                  v-for="(periode, key) in periode_grade_collection"
                  :value="periode.id"
                  :key="key">
                  {{ periode.name }}
                </option>
              </b-select>
            </b-field>

            <b-table v-if="!isEmpty(data_grade)" :data="data_grade.mataKuliah">
              <template slot-scope="props">
                <b-table-column field="namaMataKuliah" label="Mata Kuliah">
                  <p class="title" style="font-size: 15px;">{{ props.row.namaMataKuliah }}</p>
                  <p class="subtitle" style="font-size: 14px;">{{ props.row.kodeMataKuliah }}</p>
                </b-table-column>

                <b-table-column field="sks" label="SKS">
                  {{ props.row.sks || '0' }}
                </b-table-column>

                <b-table-column field="nilaiHuruf" label="Nilai Huruf">
                  {{ props.row.nilaiHuruf || '-' }}
                </b-table-column>

                <b-table-column field="nilaiAngka" label="Nilai Angka">
                  {{ props.row.nilaiAngka || '-' }}
                </b-table-column>

                <b-table-column field="nilaiAkhir" label="Nilai Akhir">
                  {{ props.row.nilaiAkhir || '-' }}
                </b-table-column>
              </template>
            </b-table>
          </section>
          <footer class="modal-card-foot">
          </footer>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { ACCOUNT } from '~/consts';

export default {
  props: {
    account: {
      type: Object,
      default: null
    },
    onHide: {
      type: Function,
      default: () => {}
    }
  },

  computed: {
    nim() {
      if (!this.isEmpty(this.account)) {
        return this.account.userUniversityId
      }

      return null;
    },
    periode_grade_collection() {
      return collect(this.grade).map((i) => {
        return {
          id: i.idperiode,
          name: i.periode
        }
      }).toArray()
    },
    data_grade() {
      if (!this.isEmpty(this.grade)) {
        return collect(this.grade).where('idperiode', this.periode_grade).first();
      }

      return [];
    },
    show: {
      get() {
        return !this.isEmpty(this.nim) ? true : false
      },
      set() {
        this.onHide();
      }
    }
  },

  watch: {
    account(val) {
      if (!this.isEmpty(val)) {
        this.getData()
      } else {
        this.grade = [];
        this.periode_grade = null
      }
    },
  },

  data() {
    return {
      periode_grade: null,
      grade: [],
    }
  },

  methods: {
    getData() {
      const vm = this;

      this.$axios.post(ACCOUNT.GET_GRADE(this.account.universityId), {
        isDefault: 0,
        user_university_id: this.nim
      }).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          vm.grade = data.data;
        } else {
          this.$buefy.toast.open(data.applicationSystem.message);
        }
      }).catch(({ response }) => {
      })
    }
  }
}
</script>

<style>

</style>
